
/** CareCraft */
export const GET_LOGS_SKU = 'GET_LOGS_SKU';
export const GET_LOGS_SKU_SUCCESS = 'GET_LOGS_SKU_SUCCESS';

export const RESOLVE_SINGLE_LOGS_SKU = 'RESOLVE_SINGLE_LOGS_SKU';

export const GET_PRICE_ERRORS = 'GET_PRICE_ERRORS';
export const GET_PRICE_ERRORS_SUCCESS = 'GET_PRICE_ERRORS_SUCCESS';

